import React from 'react';
import { BookOpenIcon, MapIcon, PrinterIcon, ZapIcon } from 'lucide-react';
const items = [{
  icon: MapIcon,
  label: '130 mapas visuales'
}, {
  icon: BookOpenIcon,
  label: 'Basado en la Biblia'
}, {
  icon: PrinterIcon,
  label: 'Listo para imprimir en A4'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Stats() {
  return <section className="w-full bg-coal-900 py-4" data-id="element-145" data-mp="2nv7dhxll4fyt">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-146" data-mp="297mcc989sqtj">
        <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3" data-id="element-147" data-mp="296b49x7skwwm">
          {items.map(item => <li key={item.label} className="inline-flex items-center gap-2.5 text-sm font-bold text-white" data-id="element-148" data-mp="207pna6hyxpxy">
              <item.icon className="h-4 w-4 shrink-0 text-forest-400" aria-hidden="true" data-id="element-149" data-mp="256skx5vmctvw" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}